module.exports = "<tr>\n  <th>Содержит слова</th>\n  <td>\n    <words source=\"source.description_include.value\" placeholder=\"Укажите любое слово\"/>\n  </td>\n</tr>\n<tr>\n  <th>Исключить слова</th>\n  <td>\n    <words source=\"source.description_exclude.value\" negative placeholder=\"Укажите любое слово\"/>\n  </td>\n</tr>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/advanced-browser/templates/sections/keywords.html
// module id = 347
// module chunks = 0